import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';
import { useGetCurrentOrganisationId } from 'hooks';

import { getBoardUsers } from '../requests';
import type {
  GetBoardUsersRequestType,
  GetBoardUsersResponseType,
} from '../types';

export const useGetBoardUsers = (
  {
    pathParams: { boardId },
    queryParams,
  }: {
    pathParams: Omit<GetBoardUsersRequestType['pathParams'], 'organisationId'>;
    queryParams?: GetBoardUsersRequestType['queryParams'];
  },
  options?: UseQueryOptions<GetBoardUsersResponseType>,
) => {
  const organisationId = useGetCurrentOrganisationId();
  const page = queryParams?.page || 1;
  const perPage = queryParams?.perPage || 20;

  return useQuery({
    queryKey: [
      API_QUERY_KEYS.boardUsers,
      organisationId,
      boardId,
      { page, perPage },
    ],
    queryFn: () =>
      getBoardUsers({
        pathParams: { organisationId, boardId },
        queryParams: { page, perPage },
      }),
    ...options,
  });
};
